import { useMutation } from "@tanstack/react-query";
import {
  registerUser,
  loginUser,
  loginWithGoogle,
  verifyEmail,
  resendPin,
  forgotPassword,
  verifyResetPin,
  resetPassword,
  changePassword,
  logoutUser,
} from "@/lib/auth/auth";

export const useRegister = () => {
  return useMutation({
    mutationFn: registerUser,
  });
};

export const useLogin = () => {
  return useMutation({
    mutationFn: loginUser,
  });
};

export const useGoogleLogin = () => {
  return useMutation({
    mutationFn: loginWithGoogle,
  });
};

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: verifyEmail,
  });
};

export const useResendPin = () => {
  return useMutation({
    mutationFn: resendPin,
  });
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword,
  });
};

export const useVerifyResetPin = () => {
  return useMutation({
    mutationFn: verifyResetPin,
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: resetPassword,
  });
};

export const useChangePassword = () => {
  return useMutation({
    mutationFn: changePassword,
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: logoutUser,
  });
};
